import { useEffect, useState } from "react";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { Button, Form, Row } from "reactstrap";
import { H4 } from "../../../AbstractElements";
import useAxios from "../../../Utils/useAxios";
import updateShift from "../services/updateShift";
import BerkasViewer from "./PreviewBerkas";
import InformasiCard from "./PreviewInformasi";
import PreviewShiftList from "./PreviewShiftList";

const PreviewShift = ({ setMode, resetState, shift }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [stafList, setStafList] = useState([]);
  const [dateList, setDateList] = useState([]);
  const axiosInstance = useAxios();

  useEffect(() => {
    if (shift?.data?.[0]?.shifts?.periode) {
      const monthDate = new Date(shift.data[0].shifts.periode);
      let monthList = [];
      
      const lastDay = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0).getDate();

      for (let i = 1; i <= lastDay; i++) {
        monthList.push({
          tanggal: new Date(monthDate.getFullYear(), monthDate.getMonth(), i),
        });
      }
      setDateList(monthList);

      const transformedData = shift.data.map((staff) => ({
        nama: staff.nama,
        nip: staff.nip,
        shift: staff.shifts.daily_shifts.map((day) => ({
          tanggal: day.date,
          shift: day.shift,
          shift_display: day.shift_display
        })),
      }));
      setStafList(transformedData);
    }
  }, [shift]);

  const postItem = () => {
    setIsSubmitting(true);

    const submitData = {
      title: {
        month_year: shift.data[0].shifts.periode,
        location: shift.data[0].shifts.lokasi,
        days_in_month: dateList.length
      },
      schedules: shift.data.map(staff => ({
        nip: staff.nip,
        name: staff.nama,
        schedule: staff.shifts.daily_shifts.map(day => ({
          date: day.date,
          periode: day.shift_display,
          shift: day.shift
        }))
      }))
    };

    const dataToSend = {
      data: submitData,
      berkas: shift.berkas
    };

    updateShift(axiosInstance, dataToSend)
      .then(() => {
        setIsSubmitting(false);
        resetState();
        setMode("list");
      })
      .catch(error => {
        console.error("Error saving shift:", error);
        setIsSubmitting(false);
      });
  };

  return (
    <Form>
      <div className="text-center mb-3">
        <H4>Preview Jadwal Shift</H4>
      </div>
      <Row className="mb-3">
        <InformasiCard shift={shift} />
        <BerkasViewer berkas={shift?.berkas} />
      </Row>
      <PreviewShiftList stafList={stafList} dateList={dateList} />
      <div className="d-flex justify-content-between mt-3">
        <Button color="secondary" type="button" onClick={() => setMode("list")}>
          Kembali
        </Button>
        <Button
          color="primary"
          type="submit"
          disabled={isSubmitting}
          onClick={(e) => {
            e.preventDefault();
            postItem();
          }}
        >
          {isSubmitting ? "Mengirim..." : "Simpan"}
        </Button>
      </div>
    </Form>
  );
};

export default PreviewShift;